export default function LogoMark({ size = 96, className = "", title = "UnAnonymous" }) {
  const id = `un-logo-${String(size).replace(/\W/g, "")}`;
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={title}
    >
      <defs>
        <radialGradient id={`${id}-halo`} cx="50%" cy="45%" r="58%">
          <stop offset="0%" stopColor="#fff4d7" stopOpacity="0.98" />
          <stop offset="62%" stopColor="#d6b884" stopOpacity="0.34" />
          <stop offset="100%" stopColor="#d6b884" stopOpacity="0" />
        </radialGradient>
        <radialGradient id={`${id}-head`} cx="65%" cy="25%" r="80%">
          <stop offset="0%" stopColor="#d6b884" />
          <stop offset="38%" stopColor="#7b4c6c" />
          <stop offset="100%" stopColor="#4a2d48" />
        </radialGradient>
        <linearGradient id={`${id}-leaf`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#936d8e" />
          <stop offset="100%" stopColor="#4a2d48" />
        </linearGradient>
      </defs>
      <circle cx="60" cy="59" r="58" fill={`url(#${id}-halo)`} />
      <circle cx="60" cy="42" r="15" fill={`url(#${id}-head)`} />
      <path
        d="M56 62C42 59 27 51 17 39c-4 20 0 41 14 55 9 9 19 13 29 15 3-17 2-33-4-47Z"
        fill={`url(#${id}-leaf)`}
      />
      <path
        d="M64 62c14-3 29-11 39-23 4 20 0 41-14 55-9 9-19 13-29 15-3-17-2-33 4-47Z"
        fill={`url(#${id}-leaf)`}
      />
      <path d="M60 62v46" stroke="#f7f1ea" strokeWidth="2.2" strokeLinecap="round" opacity="0.86" />
    </svg>
  );
}
